import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";
import { useState } from "react";


const EMPTY_ATCD = () => ({
  pathologie: "",
  date_decouverte: "",
  suit_traitement: "",
  precision_traitement: "",
  soin: "",
  hospitalisation: "",
});

const ExpositionBloc = ({ travailKey, expositionKey, form, onChange }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const expositions = Array.isArray(form[expositionKey]) ? form[expositionKey] : [];

  const handleTravail = (val) => {
    onChange(travailKey, val);
    if (val === "oui" && expositions.length === 0) {
      onChange(expositionKey, [""]);
      setCurrentIndex(0);
    }
    if (val === "non") {
      onChange(expositionKey, []);
      setCurrentIndex(0);
    }
  };

  const handleAdd = () => {
    const updated = [...expositions, ""];
    onChange(expositionKey, updated);
    setCurrentIndex(updated.length - 1);
  };

  const handleRemove = () => {
    if (expositions.length <= 1) return;
    const updated = expositions.filter((_, i) => i !== currentIndex);
    onChange(expositionKey, updated);
    setCurrentIndex(Math.max(0, currentIndex - 1));
  };

  const handleChange = (value) => {
    const updated = [...expositions];
    updated[currentIndex] = value;
    onChange(expositionKey, updated);
  };

  return (
    <div className="om-row" style={{ flexWrap: "wrap", gap: "0.75rem" }}>
      <div className="om-field-group om-field-group--radio" style={{ minWidth: "160px", flex: "0 0 auto" }}>
        <label>Travail à haut risque</label>
        <div className="om-atcd-radio-row">
          {["oui", "non"].map((val) => (
            <label key={val} className="om-radio-inline">
              <input type="radio"
                name={travailKey}
                value={val}
                checked={form[travailKey] === val}
                onChange={() => handleTravail(val)} />
              {val === "oui" ? "Oui" : "Non"}
            </label>
          ))}
        </div>
      </div>

      {form[travailKey] === "oui" && expositions.length > 0 && (
        <div className="om-field-group" style={{ flex: "1 1 300px", minWidth: 0 }}>
          <label>Exposition</label>
          <input type="text" placeholder="Ex : amiante, poussière de bois..."
            value={expositions[currentIndex] ?? ""}
            onChange={(e) => handleChange(e.target.value)} />
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginTop: "0.5rem", flexWrap: "wrap" }}>
            <select
              value={currentIndex}
              onChange={(e) => setCurrentIndex(parseInt(e.target.value))}
              className="dt-projet-select">
              {expositions.map((_, i) => (
                <option key={i} value={i}>Exposition {i + 1}</option>
              ))}
            </select>
            <button type="button" onClick={handleAdd} className="om-bloc-btn om-bloc-btn--add">
              + Ajouter
            </button>
            <button type="button" onClick={handleRemove} disabled={expositions.length <= 1}
              className="om-bloc-btn om-bloc-btn--remove">
              🗑 Supprimer
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const BlocAtcd = ({ items, onChange, gc, prefix }) => {
  const list = Array.isArray(items) && items.length > 0 ? items : [EMPTY_ATCD()];

  const update = (index, field, value) => {
    const updated = [...list];
    updated[index] = { ...updated[index], [field]: value };
    onChange(updated);
  };

  const add = () => onChange([...list, EMPTY_ATCD()]);

  const remove = (index) => {
    if (list.length === 1) return;
    onChange(list.filter((_, i) => i !== index));
  };

  return (
    <div className="om-atcd-list">
      {list.map((item, i) => (
        <div key={i} className="om-atcd-bloc">
          {/* Ligne 1 : pathologie, date, traitement */}
          <div className="om-atcd-row">
            <div className="om-atcd-field">
              <label>Pathologie</label>
              <input type="text" placeholder="Pathologie..." value={item.pathologie ?? ""}
                onChange={(e) => update(i, "pathologie", e.target.value)} />
            </div>
            <div className="om-atcd-field om-atcd-field--small">
              <label>Date découverte</label>
              <input type="date" value={item.date_decouverte ?? ""}
                onChange={(e) => update(i, "date_decouverte", e.target.value)} />
            </div>
            <div className="om-atcd-field om-atcd-field--radio">
              <label>Suit un traitement</label>
              <div className="om-atcd-radio-row">
                {["oui", "non"].map((val) => (
                  <label key={val} className="om-radio-inline">
                    <input type="radio" name={`${prefix}_traitement_${i}`}
                      value={val}
                      checked={item.suit_traitement === val}
                      onChange={() => update(i, "suit_traitement", val)} />
                    {val === "oui" ? "Oui" : "Non"}
                  </label>
                ))}
                {item.suit_traitement === "oui" && (
                  <input type="text" placeholder="Préciser..." className="om-atcd-precision"
                    value={item.precision_traitement ?? ""}
                    onChange={(e) => update(i, "precision_traitement", e.target.value)} />
                )}
              </div>
            </div>
          </div>

          {/* Ligne 2 : soin + hospitalisation */}
          <div className="om-atcd-row om-atcd-row--textareas">
            <div className="om-atcd-field">
              <label>Soin</label>
              <textarea rows={2} placeholder="Soin..." value={item.soin ?? ""}
                onChange={(e) => update(i, "soin", e.target.value)} />
            </div>
            <div className="om-atcd-field">
              <label>Hospitalisation</label>
              <textarea rows={2} placeholder="Hospitalisation..." value={item.hospitalisation ?? ""}
                onChange={(e) => update(i, "hospitalisation", e.target.value)} />
            </div>
          </div>

          {/* Ligne 3 : boutons */}
          <div className="om-atcd-actions">
            <button type="button" className="om-atcd-btn om-atcd-btn--add" onClick={add}>＋ Ajouter</button>
            {list.length > 1 && (
              <button type="button" className="om-atcd-btn om-atcd-btn--remove" onClick={() => remove(i)}>🗑 Supprimer</button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

const Tab2Antecedents = ({ form, onChange, activeSub, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));

  return (
    <div className="om-fields">

      {/* ── Personnels ── */}
      {activeSub === "personnels" && (
        <>
          <div className="om-section-label">Périnataux (réservé nourrissons)</div>
          <div className="om-row">
            <div className="om-field-group">
              <label>PN <ConfidenceLabel confidence={gc("pn")} /></label>
              <input type="text" placeholder="PN" value={form.pn ?? ""}
                onChange={(e) => onChange("pn", e.target.value)}
                style={{ borderColor: gc("pn").color || undefined }} />
            </div>
            <div className="om-field-group">
              <label>TN <ConfidenceLabel confidence={gc("tn")} /></label>
              <input type="text" placeholder="TN" value={form.tn ?? ""}
                onChange={(e) => onChange("tn", e.target.value)}
                style={{ borderColor: gc("tn").color || undefined }} />
            </div>
            <div className="om-field-group">
              <label>PCN <ConfidenceLabel confidence={gc("pcn")} /></label>
              <input type="text" placeholder="PCN" value={form.pcn ?? ""}
                onChange={(e) => onChange("pcn", e.target.value)}
                style={{ borderColor: gc("pcn").color || undefined }} />
            </div>
          </div>
          <div className="om-section-label">APGAR</div>
          <div className="om-row">
            <div className="om-field-group">
              <label>1 min après naissance <ConfidenceLabel confidence={gc("apgar_one_min")} /></label>
              <input type="text" placeholder="—" value={form.apgar_one_min ?? ""}
                onChange={(e) => onChange("apgar_one_min", e.target.value)}
                style={{ borderColor: gc("apgar_one_min").color || undefined }} />
            </div>
            <div className="om-field-group">
              <label>5 min après naissance <ConfidenceLabel confidence={gc("apgar_five_min")} /></label>
              <input type="text" placeholder="—" value={form.apgar_five_min ?? ""}
                onChange={(e) => onChange("apgar_five_min", e.target.value)}
                style={{ borderColor: gc("apgar_five_min").color || undefined }} />
            </div>
          </div>
          <div className="om-field-group">
            <label>Âge des acquisitions psychomotrices <ConfidenceLabel confidence={gc("age_acquisitions")} /></label>
            <input type="text" placeholder="Ex : marche à 12 mois..." value={form.age_acquisitions ?? ""}
              onChange={(e) => onChange("age_acquisitions", e.target.value)}
              style={{ borderColor: gc("age_acquisitions").color || undefined }} />
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Carnet de vaccination disponible <ConfidenceLabel confidence={gc("carnet_vaccination")} /></label>
              <select value={form.carnet_vaccination ?? ""} onChange={(e) => onChange("carnet_vaccination", e.target.value)}
                style={{ borderColor: gc("carnet_vaccination").color || undefined }}>
                <option value="">—</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>
            </div>
            {form.carnet_vaccination === "oui" && (
              <div className="om-field-group">
                <label>Vaccins à jour <ConfidenceLabel confidence={gc("vaccins_a_jour")} /></label>
                <select value={form.vaccins_a_jour ?? ""} onChange={(e) => onChange("vaccins_a_jour", e.target.value)}
                  style={{ borderColor: gc("vaccins_a_jour").color || undefined }}>
                  <option value="">—</option>
                  <option value="oui">Oui</option>
                  <option value="non">Non</option>
                </select>
              </div>
            )}
          </div>
          <div className="om-field-group">
            <label>Vaccins non faits <ConfidenceLabel confidence={gc("vaccins_non_faits")} /></label>
            <input type="text" placeholder="Préciser les vaccins non faits..." value={form.vaccins_non_faits ?? ""}
              onChange={(e) => onChange("vaccins_non_faits", e.target.value)}
              style={{ borderColor: gc("vaccins_non_faits").color || undefined }} />
          </div>
          <div className="om-field-group">
            <label>Antécédents médicaux <ConfidenceLabel confidence={gc("antecedents_medicaux")} /></label>
            <textarea rows={3} placeholder="Décrire les antécédents médicaux..." value={form.antecedents_medicaux ?? ""}
              onChange={(e) => onChange("antecedents_medicaux", e.target.value)}
              style={{ borderColor: gc("antecedents_medicaux").color || undefined }} />
          </div>
          <div className="om-field-group">
            <label>Antécédents chirurgicaux <ConfidenceLabel confidence={gc("antecedents_chirurgicaux")} /></label>
            <textarea rows={3} placeholder="Décrire les antécédents chirurgicaux..." value={form.antecedents_chirurgicaux ?? ""}
              onChange={(e) => onChange("antecedents_chirurgicaux", e.target.value)}
              style={{ borderColor: gc("antecedents_chirurgicaux").color || undefined }} />
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Antécédent de cancer <ConfidenceLabel confidence={gc("antecedent_cancer")} /></label>
              <select value={form.antecedent_cancer ?? ""} onChange={(e) => onChange("antecedent_cancer", e.target.value)}
                style={{ borderColor: gc("antecedent_cancer").color || undefined }}>
                <option value="">—</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>
            </div>
            <div className="om-field-group">
              <label>Transfusions antérieures <ConfidenceLabel confidence={gc("transfusions")} /></label>
              <select value={form.transfusions ?? ""} onChange={(e) => onChange("transfusions", e.target.value)}
                style={{ borderColor: gc("transfusions").color || undefined }}>
                <option value="">—</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>
            </div>
          </div>
          {form.transfusions === "oui" && (
            <div className="om-row">
              <div className="om-field-group">
                <label>Nombre de transfusions <ConfidenceLabel confidence={gc("transfusions_nombre")} /></label>
                <input type="number" min="0" placeholder="Nombre" value={form.transfusions_nombre ?? ""}
                  onChange={(e) => onChange("transfusions_nombre", e.target.value)}
                  style={{ borderColor: gc("transfusions_nombre").color || undefined }} />
              </div>
              <div className="om-field-group">
                <label>Date approximative de la dernière <ConfidenceLabel confidence={gc("transfusion_date")} /></label>
                <input type="date" value={form.transfusion_date ?? ""}
                  onChange={(e) => onChange("transfusion_date", e.target.value)}
                  style={{ borderColor: gc("transfusion_date").color || undefined }} />
              </div>
            </div>
          )}
        </>
      )}

      {/* ── Familiaux ── */}
      {activeSub === "familiaux" && (
        <>
          <div className="om-sub-section">Père</div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Vivant <ConfidenceLabel confidence={gc("pere_vivant")} /></label>
              <select value={form.pere_vivant ?? ""} onChange={(e) => onChange("pere_vivant", e.target.value)}
                style={{ borderColor: gc("pere_vivant").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.pere_vivant === "non" && (
              <div className="om-field-group">
                <label>Cause du décès <ConfidenceLabel confidence={gc("pere_cause_deces")} /></label>
                <input type="text" placeholder="Préciser..." value={form.pere_cause_deces ?? ""}
                  onChange={(e) => onChange("pere_cause_deces", e.target.value)}
                  style={{ borderColor: gc("pere_cause_deces").color || undefined }} />
              </div>
            )}
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Antécédent cancer chez le père <ConfidenceLabel confidence={gc("pere_cancer")} /></label>
              <select value={form.pere_cancer ?? ""} onChange={(e) => onChange("pere_cancer", e.target.value)}
                style={{ borderColor: gc("pere_cancer").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.pere_cancer === "oui" && (
              <div className="om-field-group">
                <label>Type de cancer <ConfidenceLabel confidence={gc("pere_cancer_type")} /></label>
                <input type="text" placeholder="Préciser..." value={form.pere_cancer_type ?? ""}
                  onChange={(e) => onChange("pere_cancer_type", e.target.value)}
                  style={{ borderColor: gc("pere_cancer_type").color || undefined }} />
              </div>
            )}
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Cancer dans la famille du père <ConfidenceLabel confidence={gc("pere_famille_cancer")} /></label>
              <select value={form.pere_famille_cancer ?? ""} onChange={(e) => onChange("pere_famille_cancer", e.target.value)}
                style={{ borderColor: gc("pere_famille_cancer").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          {form.pere_famille_cancer === "oui" && (
            <div className="om-row">
              <div className="om-field-group">
                <label>Type de cancer (famille père) <ConfidenceLabel confidence={gc("pere_famille_cancer_type")} /></label>
                <input type="text" placeholder="Préciser..." value={form.pere_famille_cancer_type ?? ""}
                  onChange={(e) => onChange("pere_famille_cancer_type", e.target.value)}
                  style={{ borderColor: gc("pere_famille_cancer_type").color || undefined }} />
              </div>
              <div className="om-field-group">
                <label>Lien de parenté <ConfidenceLabel confidence={gc("pere_famille_lien")} /></label>
                <input type="text" placeholder="Préciser..." value={form.pere_famille_lien ?? ""}
                  onChange={(e) => onChange("pere_famille_lien", e.target.value)}
                  style={{ borderColor: gc("pere_famille_lien").color || undefined }} />
              </div>
            </div>
          )}
          <div className="om-row">
            {[["pere_alcoolisme","Alcoolisme"],["pere_tabagisme","Tabagisme"],["pere_drogues","Drogues"]].map(([key, label]) => (
              <div key={key} className="om-field-group">
                <label>{label} <ConfidenceLabel confidence={gc(key)} /></label>
                <select value={form[key] ?? "non"} onChange={(e) => onChange(key, e.target.value)}
                  style={{ borderColor: gc(key).color || undefined }}>
                  <option value="non">Non</option>
                  <option value="oui">Oui</option>
                </select>
              </div>
            ))}
          </div>
          <ExpositionBloc
            travailKey="travail_haut_risque_pere"
            expositionKey="exposition_pere"
            form={form}
            onChange={onChange}
          />
          <div className="om-field-group">
            <label>Autres antécédents pathologiques (père)</label>
            <BlocAtcd
              items={form.pere_autres_atcd}
              onChange={(val) => onChange("pere_autres_atcd", val)}
              gc={gc}
              prefix="pere"
            />
          </div>

          <div className="om-divider" />

          <div className="om-sub-section">Mère</div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Vivante <ConfidenceLabel confidence={gc("mere_vivante")} /></label>
              <select value={form.mere_vivante ?? ""} onChange={(e) => onChange("mere_vivante", e.target.value)}
                style={{ borderColor: gc("mere_vivante").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.mere_vivante === "non" && (
              <div className="om-field-group">
                <label>Cause du décès <ConfidenceLabel confidence={gc("mere_cause_deces")} /></label>
                <input type="text" placeholder="Préciser..." value={form.mere_cause_deces ?? ""}
                  onChange={(e) => onChange("mere_cause_deces", e.target.value)}
                  style={{ borderColor: gc("mere_cause_deces").color || undefined }} />
              </div>
            )}
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Antécédent cancer chez la mère <ConfidenceLabel confidence={gc("mere_cancer")} /></label>
              <select value={form.mere_cancer ?? ""} onChange={(e) => onChange("mere_cancer", e.target.value)}
                style={{ borderColor: gc("mere_cancer").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.mere_cancer === "oui" && (
              <div className="om-field-group">
                <label>Type de cancer <ConfidenceLabel confidence={gc("mere_cancer_type")} /></label>
                <input type="text" placeholder="Préciser..." value={form.mere_cancer_type ?? ""}
                  onChange={(e) => onChange("mere_cancer_type", e.target.value)}
                  style={{ borderColor: gc("mere_cancer_type").color || undefined }} />
              </div>
            )}
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Cancer dans la famille de la mère <ConfidenceLabel confidence={gc("mere_famille_cancer")} /></label>
              <select value={form.mere_famille_cancer ?? ""} onChange={(e) => onChange("mere_famille_cancer", e.target.value)}
                style={{ borderColor: gc("mere_famille_cancer").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          {form.mere_famille_cancer === "oui" && (
            <div className="om-row">
              <div className="om-field-group">
                <label>Type de cancer (famille mère) <ConfidenceLabel confidence={gc("mere_famille_cancer_type")} /></label>
                <input type="text" placeholder="Préciser..." value={form.mere_famille_cancer_type ?? ""}
                  onChange={(e) => onChange("mere_famille_cancer_type", e.target.value)}
                  style={{ borderColor: gc("mere_famille_cancer_type").color || undefined }} />
              </div>
              <div className="om-field-group">
                <label>Lien de parenté <ConfidenceLabel confidence={gc("mere_famille_lien")} /></label>
                <input type="text" placeholder="Préciser..." value={form.mere_famille_lien ?? ""}
                  onChange={(e) => onChange("mere_famille_lien", e.target.value)}
                  style={{ borderColor: gc("mere_famille_lien").color || undefined }} />
              </div>
            </div>
          )}
          <div className="om-row">
            {[["mere_alcoolisme","Alcoolisme"],["mere_tabagisme","Tabagisme"],["mere_drogues","Drogues"]].map(([key, label]) => (
              <div key={key} className="om-field-group">
                <label>{label} <ConfidenceLabel confidence={gc(key)} /></label>
                <select value={form[key] ?? "non"} onChange={(e) => onChange(key, e.target.value)}
                  style={{ borderColor: gc(key).color || undefined }}>
                  <option value="non">Non</option>
                  <option value="oui">Oui</option>
                </select>
              </div>
            ))}
          </div>
              <ExpositionBloc
                travailKey="travail_haut_risque_mere"
                expositionKey="exposition_mere"
                form={form}
                onChange={onChange}
              />
              <div className="om-field-group">
                <label>Autres antécédents pathologiques (mère)</label>
                <BlocAtcd
                  items={form.mere_autres_atcd}
                  onChange={(val) => onChange("mere_autres_atcd", val)}
                  gc={gc}
                  prefix="mere"
                />
              </div>

          <div className="om-divider" />

          <div className="om-sub-section">Fratrie</div>
          <div className="om-row">
            <div className="om-field-group om-field-group--small">
              <label>Nombre <ConfidenceLabel confidence={gc("fratrie_nombre")} /></label>
              <input type="number" min="0" placeholder="Ex : 4" value={form.fratrie_nombre ?? ""}
                onChange={(e) => onChange("fratrie_nombre", e.target.value)}
                style={{ borderColor: gc("fratrie_nombre").color || undefined }} />
            </div>
            <div className="om-field-group">
              <label>Âge(s) <ConfidenceLabel confidence={gc("fratrie_ages")} /></label>
              <input type="text" placeholder="Ex : 30a, 22a, 15a..." value={form.fratrie_ages ?? ""}
                onChange={(e) => onChange("fratrie_ages", e.target.value)}
                style={{ borderColor: gc("fratrie_ages").color || undefined }} />
            </div>
            <div className="om-field-group om-field-group--small">
              <label>Scolarisés <ConfidenceLabel confidence={gc("fratrie_scolarises")} /></label>
              <input type="number" min="0" placeholder="Nb" value={form.fratrie_scolarises ?? ""}
                onChange={(e) => onChange("fratrie_scolarises", e.target.value)}
                style={{ borderColor: gc("fratrie_scolarises").color || undefined }} />
            </div>
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Antécédents de cancer (fratrie) <ConfidenceLabel confidence={gc("fratrie_cancer")} /></label>
              <select value={form.fratrie_cancer ?? ""} onChange={(e) => onChange("fratrie_cancer", e.target.value)}
                style={{ borderColor: gc("fratrie_cancer").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.fratrie_cancer === "oui" && (
              <div className="om-field-group">
                <label>Type de cancer <ConfidenceLabel confidence={gc("fratrie_cancer_type")} /></label>
                <input type="text" placeholder="Préciser..." value={form.fratrie_cancer_type ?? ""}
                  onChange={(e) => onChange("fratrie_cancer_type", e.target.value)}
                  style={{ borderColor: gc("fratrie_cancer_type").color || undefined }} />
              </div>
            )}
          </div>
          <ExpositionBloc
            travailKey="travail_haut_risque_fratrie"
            expositionKey="exposition_fratrie"
            form={form}
            onChange={onChange}
          />
          <div className="om-field-group">
            <label>Autres informations utiles <ConfidenceLabel confidence={gc("fratrie_autres")} /></label>
            <textarea rows={3} placeholder="Autres informations..." value={form.fratrie_autres ?? ""}
              onChange={(e) => onChange("fratrie_autres", e.target.value)}
              style={{ borderColor: gc("fratrie_autres").color || undefined }} />
          </div>
          <div className="om-field-group">
            <label>Autres antécédents pathologiques (fratrie)</label>
            <BlocAtcd
              items={form.fratrie_autres_atcd}
              onChange={(val) => onChange("fratrie_autres_atcd", val)}
              gc={gc}
              prefix="fratrie"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Tab2Antecedents;